import { styled } from "@l2r-front/l2r-ui"

import { ADDITIONAL_SIDEBAR_WIDTH } from "../../constants/layout"
import { Map as MapComponent } from "../../containers/Map"

export const Wrapper = styled("div")({
    display: "flex",
    width: "100%",
    height: "100%",
})

export const Map = styled(MapComponent, { shouldForwardProp: (prop) => prop !== "sidebarCount" && prop !== "mapHeightPct" })(({ sidebarCount, mapHeightPct }) => {
    return ({
        height: "100%",
        width: mapHeightPct === 0 ? "100%" : `calc(100% - ${(sidebarCount - 1) * ADDITIONAL_SIDEBAR_WIDTH}px)`,
        paddingLeft: mapHeightPct === 0 ? 0 : `calc(${(sidebarCount - 1) * ADDITIONAL_SIDEBAR_WIDTH}px)`,
        marginLeft: "auto",
    })
})